import { render, staticRenderFns } from "./AccountInfoCollapsibleList.vue?vue&type=template&id=74809bd2&"
import script from "./AccountInfoCollapsibleList.vue?vue&type=script&lang=js&"
export * from "./AccountInfoCollapsibleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports